var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 50.625c5.592 0 10.125-4.533 10.125-10.125S46.092 30.375 40.5 30.375 30.375 34.908 30.375 40.5 34.908 50.625 40.5 50.625z",
    stroke: "#24FF00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.475 50.625a5.569 5.569 0 001.114 6.142l.202.203a6.751 6.751 0 01-2.19 11.016 6.75 6.75 0 01-7.361-1.465l-.203-.202a5.57 5.57 0 00-6.142-1.114 5.568 5.568 0 00-3.375 5.096v.574a6.75 6.75 0 01-13.5 0v-.304a5.568 5.568 0 00-3.645-5.096 5.569 5.569 0 00-6.142 1.114l-.203.202a6.751 6.751 0 01-11.016-2.19 6.75 6.75 0 011.465-7.361l.202-.203a5.569 5.569 0 001.114-6.142 5.568 5.568 0 00-5.096-3.375h-.574a6.75 6.75 0 010-13.5h.304a5.568 5.568 0 005.096-3.645 5.569 5.569 0 00-1.114-6.142l-.202-.203a6.75 6.75 0 010-9.551 6.75 6.75 0 019.551 0l.202.202a5.569 5.569 0 006.143 1.114h.27a5.568 5.568 0 003.375-5.096v-.574a6.75 6.75 0 0113.5 0v.304a5.568 5.568 0 003.375 5.096 5.569 5.569 0 006.142-1.114l.203-.202a6.75 6.75 0 019.551 0 6.75 6.75 0 010 9.551l-.202.202a5.57 5.57 0 00-1.114 6.143v.27a5.568 5.568 0 005.096 3.375h.574a6.75 6.75 0 010 13.5h-.304a5.568 5.568 0 00-5.096 3.375v0z",
    stroke: "#24FF00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/Cog.e63445a9f8a8e145cb0efc384151393a.svg";
export { ForwardRef as ReactComponent };